'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('./utils');

var _mobx = require('mobx');

var _asyncValidator = require('async-validator');

var _asyncValidator2 = _interopRequireDefault(_asyncValidator);

var _lodash = require('lodash.set');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.get');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.has');

var _lodash6 = _interopRequireDefault(_lodash5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_VALIDATE_TRIGGER = 'onChange';
var DEFAULT_TRIGGER = DEFAULT_VALIDATE_TRIGGER;

function createForm() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var gStore = options.store,
      _options$prefix = options.prefix,
      prefix = _options$prefix === undefined ? '' : _options$prefix,
      _options$defaultItemP = options.defaultItemProps,
      defaultItemProps = _options$defaultItemP === undefined ? {} : _options$defaultItemP,
      _options$displayDefau = options.displayDefaultLabel,
      displayDefaultLabel = _options$displayDefau === undefined ? true : _options$displayDefau;


  function decorate(WrappedComponent) {
    var _class, _temp2;

    var WrapForm = (_temp2 = _class = function (_Component) {
      _inherits(WrapForm, _Component);

      function WrapForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WrapForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrapForm.__proto__ || Object.getPrototypeOf(WrapForm)).call.apply(_ref, [this].concat(args))), _this), _this.errors = _mobx.observable.map(), _this.fieldOptions = {}, _this.store = {}, _this.validateFields = function (callback) {
          var needValidateName = [];
          var rules = Object.keys(_this.fieldOptions).reduce(function (o, name) {
            var rules = _this.fieldOptions[name].rules;
            if (rules) {
              needValidateName.push(name);
              o[name] = rules;
            }
            return o;
          }, {});
          var validator = new _asyncValidator2.default(rules);
          return new Promise(function (res, rej) {
            var values = (0, _mobx.toJS)(_this.getTargetFields());
            // flatten values that need validate
            var flattenValue = needValidateName.reduce(function (o, cur) {
              o[cur] = _this.getField(cur);
              return o;
            }, {});
            validator.validate(flattenValue, (0, _mobx.action)(function (err, fields) {
              _this.errors.merge(fields);
              if (fields) {
                callback ? callback(fields) : rej(fields);
              } else {
                res(values);
              }
            }));
          });
        }, _this.getFieldError = function (name) {
          return _this.errors.get(name);
        }, _this.getFieldsError = function () {
          return _this.errors.toJS();
        }, _this.getStore = function () {
          return _this.props.store || gStore || _this.store;
        }, _this.getFieldProps = function (name) {
          var _extends2;

          var customFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          var store = _this.getStore();
          if (!store) throw new Error('Must pass `store` with Mobx instance.');
          if (!name) {
            throw new Error('Must call `getFieldProps` with valid name string!');
          }

          var options = store.__options && store.__options[name] || {};

          var fieldOption = _extends({
            getValueFromEvent: _utils.getValueFromEvent,
            name: name,
            valuePropName: 'value',
            trigger: DEFAULT_TRIGGER,
            validateTrigger: DEFAULT_VALIDATE_TRIGGER,
            appendProps: {}
          }, options, customFieldOption);

          var trigger = fieldOption.trigger,
              validateTrigger = fieldOption.validateTrigger,
              valuePropName = fieldOption.valuePropName,
              parseValue = fieldOption.parseValue,
              appendProps = fieldOption.appendProps,
              initialValue = fieldOption.initialValue;


          if (!(0, _lodash6.default)(store, name)) (0, _mobx.extendObservable)(store, (0, _lodash2.default)({}, prefix ? prefix + '.' + name : name, initialValue));

          var value = _this.getField(name);
          _this.fieldOptions[name] = fieldOption;

          var props = _extends((_extends2 = {}, _defineProperty(_extends2, valuePropName, parseValue ? parseValue(value) : (0, _mobx.toJS)(value)), _defineProperty(_extends2, trigger, _this.createHandler(fieldOption, validateTrigger === trigger)), _defineProperty(_extends2, 'data-field-name', name), _extends2), appendProps);

          if (validateTrigger !== trigger) props[validateTrigger] = _this.createValidateHandler(fieldOption);
          return props;
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      /**
       * not support filter name now
       */


      _createClass(WrapForm, [{
        key: 'getChildContext',
        value: function getChildContext() {
          return { form: this, defaultItemProps: defaultItemProps, displayDefaultLabel: displayDefaultLabel };
        }
      }, {
        key: 'getTargetFields',
        value: function getTargetFields() {
          var store = this.getStore();
          return prefix ? (0, _lodash4.default)(store, prefix) : store;
        }
      }, {
        key: 'getField',
        value: function getField(path, defaultValue) {
          var store = this.getStore();
          return (0, _lodash4.default)(store, prefix ? prefix + '.' + path : path, defaultValue);
        }
      }, {
        key: 'setField',
        value: function setField(path, value) {
          var store = this.getStore();
          return (0, _lodash2.default)(store, prefix ? prefix + '.' + path : path, value);
        }
      }, {
        key: 'getResetErrors',
        value: function getResetErrors() {
          return this.errors.keys().reduce(function (o, name) {
            o[name] = [];
            return o;
          }, {});
        }
      }, {
        key: 'validateField',
        value: function validateField(name, value, rules) {
          var _this2 = this;

          if (!rules) return;
          var validator = new _asyncValidator2.default(_defineProperty({}, name, rules));
          validator.validate(_defineProperty({}, name, value), (0, _mobx.action)('validateField', function (err, fields) {
            _this2.errors.set(name, err || []);
          }));
        }
      }, {
        key: 'createHandler',
        value: function createHandler(_ref3) {
          var _this3 = this;

          var name = _ref3.name,
              onChange = _ref3.onChange,
              rules = _ref3.rules,
              getValueFromEvent = _ref3.getValueFromEvent;
          var needValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

          return function () {
            var value = getValueFromEvent.apply(undefined, arguments);
            onChange && onChange(value);
            needValidate && _this3.validateField(name, value, rules);
            _this3.setField(name, value);
          };
        }
      }, {
        key: 'createValidateHandler',
        value: function createValidateHandler(_ref4) {
          var _this4 = this;

          var name = _ref4.name,
              rules = _ref4.rules,
              getValueFromEvent = _ref4.getValueFromEvent;

          return function () {
            var value = getValueFromEvent.apply(undefined, arguments);
            _this4.validateField(name, value, rules);
          };
        }
      }, {
        key: 'render',
        value: function render() {
          // 每次重新render时要清除已经不存在的项
          this.fieldOptions = {};
          // use __counter to force update
          // because mobx will prevent update of Component when prop not changed.
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
            form: this,
            ref: this.props.rootRef
          }));
        }
      }]);

      return WrapForm;
    }(_react.Component), _class.childContextTypes = {
      form: _react.PropTypes.object,
      defaultItemProps: _react.PropTypes.object,
      displayDefaultLabel: _react.PropTypes.bool
    }, _temp2);

    return WrapForm;
  }

  return decorate;
}

exports.default = createForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-mobx-form/lib/createForm.js
// module id = 665
// module chunks = 0